import { FeatureFlag } from 'app/api/services/site-configs/types';
import type { ConstantMenuItem } from 'app/modules/Navigation/types';
import type { ReduxState } from 'app/redux/types';

import { ROUTE_PATH } from 'app/lib/routing/constants';
import { createActiveItemDetectionSelector, createAuthItemDetectionSelector } from 'app/modules/Navigation/selectors';
import { createConstantMenuItem } from 'app/modules/Navigation/utils';

import dictionary from './Header.dictionary.json';

const HEADER_MENU_ITEMS: ConstantMenuItem[] = [
  createConstantMenuItem({
    key: 'live',
    location: ROUTE_PATH.LIVE,
    activeOn: 'betting',
    label: dictionary.sportLabel,
    title: dictionary.sportTitle,
    dataGaValues: {
      ['data-ga-event']: 'header-goLive',
    },
  }),
  createConstantMenuItem({
    key: 'externalGames',
    location: ROUTE_PATH.EXTERNAL_GAMES,
    activeOn: 'prefix-match',
    ff: FeatureFlag.ALLOW_GAMES,
    label: dictionary.externalGamesLabel,
    title: dictionary.externalGamesLabel,
    dataGaValues: {
      ['data-ga-event']: 'header-externalGames',
    },
  }),
  createConstantMenuItem({
    key: 'promotions',
    location: ROUTE_PATH.PROMOTIONS,
    ff: FeatureFlag.PROMOTIONS,
    activeOn: 'prefix-match',
    label: dictionary.promotionsLabel,
    title: dictionary.promotionsLabel,
    dataGaValues: {
      ['data-ga-event']: 'header_promo_click',
    },
  }),
  // createConstantMenuItem({
  //   key: 'results',
  //   location: '/results',
  //   activeOn: 'prefix-match',
  // }),
  // Закомментировано в связи с задачей https://jira.tennisi.it/browse/SITE-118
  // createConstantMenuItem({
  //   key: 'activeStakes',
  //   location: '/personal/active-stakes',
  //   activeOn: 'prefix-match',
  //   authOnly: true,
  // }),
];

export const headerMenuItemsWithPathname = (pathname: string) =>
  createActiveItemDetectionSelector(
    createAuthItemDetectionSelector(() => HEADER_MENU_ITEMS),
    pathname,
  );

export const selectShowEmailCollectorDialog = (state: ReduxState): boolean => {
  return state.emailCollectorDialog.show;
};
